import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { viewStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// ProductDetailsPrimaryImage
primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 300px;
            // max-width: 400px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                height: auto;
                max-width: 100%;
            }
        `,
    },
};

// ProductDetailsShareLink
shareLinkStyles.wrapper = {
    css: css`
        text-align: left;
        padding-bottom: 10px;
    `,
};

// AddToListLink
addToListLinkStyles.wrapper = {
    css: css`
        text-align: left;
        padding-top: 10px;
    `,
};

// ProductDetailsPageTitle
pageTitleStyles.titleText = {
    variant: "h1",
    css: css`
        font-size: 32px !important;
    `,
};

// ProductDetailsPartNumber
partNumberStyles.valueText = {
    size: 16,
};

// ProductQuantityOrdered
productQuantityOrderedStyles.cssOverrides = {
    formInputWrapper: css`
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -webkit-appearance: none;
            margin: 0;
        }
        margin-top: 3px !important;
    `,
};

// ProductDetailsDescription
descriptionStyles.wrapper = {
    css: css`
        font-size: 20px;
        margin-bottom: 15px;
        border-top: 2px solid ${getColor("secondary.main")};
        border-bottom: 2px solid ${getColor("secondary.main")};
        padding: 10px 0;
    `,
};

// ProductDetailsView
viewStyles.rightColumnGridItemHidden = {
    below: "md",
    css: css`
        width: 100%;
        direction: ltr;
        border: 3px solid ${getColor("primary.main")};
        padding: 8px;
        border-radius: 8px;
    `,
};
